document.addEventListener( 'DOMContentLoaded', () => {
	const tabButtons = document.querySelectorAll( '.tabs' );
	const tabs = document.querySelectorAll( '.tab' );
	// Exit early if no .tabs elements are found
	if ( tabButtons.length === 0 || tabs.length === 0 ) return;
	
	tabButtons.forEach( button => {
		button.addEventListener( 'click', () => {
			const tabName = button.getAttribute( 'data-tab' );
			// Hide all tabs
			tabs.forEach( tab => tab.classList.remove( 'active' ) );
			tabButtons.forEach( btn => btn.classList.remove( 'active' ) );
			// Show the selected tab and set the button as active
			document.getElementById( tabName ).classList.add( 'active' );
			button.classList.add( 'active' );
		});
	});
	tabs.forEach( tab => {
		const headers = tab.querySelectorAll( '.accordion-header' );
		const contents = tab.querySelectorAll( '.accordion-content' );
		// Add click event listeners to headers
		headers.forEach( header => {
			header.addEventListener('click', function() {
				const content = this.nextElementSibling;
				const isOpen = content.style.display === 'block';
				content.style.display = isOpen ? 'none' : 'block';
				this.classList.toggle( 'selected', !isOpen );
				headers.forEach( otherHeader => {
					if ( otherHeader !== this ) {
						const otherContent = otherHeader.nextElementSibling;
						otherContent.style.display = 'none'; // Hide other contents
						otherHeader.classList.remove( 'selected' );
					}
				} );
			} );
		} );
	} );
} );
